'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reduxModulesAuth = require('redux/modules/auth');

var _containersAppApp = require('./containers/App/App');

var _containersAppApp2 = _interopRequireDefault(_containersAppApp);

var _containersAppAppWithMenu = require('./containers/App/AppWithMenu');

var _containersAppAppWithMenu2 = _interopRequireDefault(_containersAppAppWithMenu);

var _containersLoginLogin = require('./containers/Login/Login');

var _containersLoginLogin2 = _interopRequireDefault(_containersLoginLogin);

var _containersNotFound = require('./containers/NotFound');

var _containersNotFound2 = _interopRequireDefault(_containersNotFound);

var _containersEmailTemplatePage = require('./containers/EmailTemplate/Page');

var _containersEmailTemplatePage2 = _interopRequireDefault(_containersEmailTemplatePage);

var _containersUserPage = require('./containers/User/Page');

var _containersUserPage2 = _interopRequireDefault(_containersUserPage);

var _containersClientPage = require('./containers/Client/Page');

var _containersClientPage2 = _interopRequireDefault(_containersClientPage);

var _containersTicketPage = require('./containers/Ticket/Page');

var _containersTicketPage2 = _interopRequireDefault(_containersTicketPage);

var _containersInvoicePage = require('./containers/Invoice/Page');

var _containersInvoicePage2 = _interopRequireDefault(_containersInvoicePage);

var _containersProjectPage = require('./containers/Project/Page');

var _containersProjectPage2 = _interopRequireDefault(_containersProjectPage);

var _containersUserProfile = require('./containers/User/Profile');

var _containersUserProfile2 = _interopRequireDefault(_containersUserProfile);

exports['default'] = function (store) {

	var requireLogin = function requireLogin(nextState, replaceState, cb) {
		function checkAuth() {
			var _store$getState = store.getState();

			var isLoggedIn = _store$getState.auth.isLoggedIn;

			if (!isLoggedIn) {
				replaceState(null, '/login?backlink=' + encodeURIComponent(nextState.location.pathname + nextState.location.search));
			}
			cb();
		}
		checkAuth();
	};

	return _react2['default'].createElement(
		_reactRouter.Route,
		{ path: '/', component: _containersAppApp2['default'] },
		_react2['default'].createElement(
			_reactRouter.Route,
			{ onEnter: requireLogin, component: _containersAppAppWithMenu2['default'] },
			_react2['default'].createElement(_reactRouter.IndexRoute, { name: 'ticket', component: _containersTicketPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/ticket(/:id)', name: 'ticket', component: _containersTicketPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/invoice(/:id)', name: 'invoice', component: _containersInvoicePage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/client(/:id)', name: 'client', component: _containersClientPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/project(/:id)', name: 'project', component: _containersProjectPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/user(/:id)', name: 'user', menu: 'setting', component: _containersUserPage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/emailtemplate(/:id)', name: 'emailtemplate', menu: 'setting', component: _containersEmailTemplatePage2['default'] }),
			_react2['default'].createElement(_reactRouter.Route, { path: '/profile', name: 'profile', component: _containersUserProfile2['default'] })
		),
		_react2['default'].createElement(_reactRouter.Route, { path: '/login', name: 'login', component: _containersLoginLogin2['default'] }),
		_react2['default'].createElement(_reactRouter.Route, { path: '*', component: _containersNotFound2['default'], status: 404 })
	);
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes.js
 ** module id = 1061
 ** module chunks = 2
 **/